module.exports = __webpack_public_path__ + "static/img/news3.ea155d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news3.jpg
// module id = x0zZ
// module chunks = 1